import React from 'react'

// Utils
import classnames from 'classnames'

import { Image as ImageC } from '@src/quince-components/src'
import Image from '@src/quince-site-common/src/domains/Image'

// Styles
import styles from './productDetailsIcon.module.scss'

export enum PRODUCT_DETAILS_ICONS {
  MINIMAL_PACKAGING = 'minimalPackaging',
  OEOKO_CERTIFIED_SVG = 'oeokoCertifiedSvg',
  REDUCED_CARBON_FOOTPRINT = 'reducedCarbonFootpring',
}

export interface ProductDetailsIconProps {
  displayTitle: string
  image?: Image
}

const ProductDetailsIcon = ({ displayTitle, image }: ProductDetailsIconProps) => {
  const classes = classnames(styles.icons)
  return (
    <div className={classes}>
      {image && <ImageC {...image} className={styles.icons__iconWrapper} />}
      <div className={styles.icons__iconText}>{displayTitle}</div>
    </div>
  )
}

export default ProductDetailsIcon
